import ExcelJS from 'exceljs'

export const parseExcelToJSON = async (file: File) => {
  const workbook = new ExcelJS.Workbook()
  await workbook.xlsx.load(await file.arrayBuffer())
  const result: any[] = []

  workbook.eachSheet(sheet => {
    const allRows: ExcelJS.CellValue[][] = []
    sheet.eachRow(row => allRows.push(row.values as ExcelJS.CellValue[]))
    if (allRows.length < 2) return

    // row.values 是 1-indexed，index 0 為 undefined，slice(1) 移除
    const headers = (allRows[0] as any[]).slice(1).map((h: any) => (h != null ? String(h) : ''))
    for (let i = 1; i < allRows.length; i++) {
      const cells = (allRows[i] as any[]).slice(1)
      const obj: Record<string, string | null> = {}
      headers.forEach((key: string, j: number) => {
        const val = cells[j]
        obj[key] = val != null ? String(val) : null
      })
      result.push(obj)
    }
  })

  return result
}